import axios from 'axios';
import { variables } from './variables.js';
import axiosInstance from './axiosInstance';

const API_URL = variables.STOCKITEM_API;

const getStockItems = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `${API_URL}?${queryString}`;
  const response = await axiosInstance.get(url);
  return response.data;
};

const getStockItem = async ( params) => {
  const queryString = params ? `${params}` : '';
  const response = await axiosInstance.get(`${API_URL}/${queryString}`);
  return response.data;
};

const addStockItem = async (item) => {
  const response = await axios.post(API_URL, item);
  return response.data;
};

const updateStockItem = async (itemId, item) => {
  const response = await axios.put(`${API_URL}/${itemId}`, item);
  return response.data;
};

const deleteStockItem = async (itemId) => {
  const response = await axios.delete(`${API_URL}/${itemId}`);
  return response.data;
};

export default {
  getStockItems,
  getStockItem,
  addStockItem,
  updateStockItem,
  deleteStockItem
};
